<header
    class="sticky top-0 z-40 flex h-16 w-full items-center justify-between border-b border-gray-200/80 bg-white/80 px-4 backdrop-blur-md sm:px-6"
>
    <!-- Left: menu toggle + page title -->
    <div class="flex items-center gap-3">
        <button
            type="button"
            aria-label="Toggle sidebar"
            (click)="toggleSidebar()"
            class="flex h-9 w-9 cursor-pointer items-center justify-center rounded-lg text-gray-500 transition-colors hover:bg-gray-100 hover:text-gray-700"
        >
            <ng-icon name="lucideMenu" class="text-xl" />
        </button>
        @if (pageTitle()) {
            <div class="hidden items-center gap-2 sm:flex">
                <span class="text-gray-300">/</span>
                <h1 class="text-[15px] font-semibold text-gray-800">
                    {{ pageTitle() }}
                </h1>
            </div>
        }
    </div>

    <!-- Right: search, notifications, profile -->
    <div class="flex items-center gap-2 sm:gap-3">
        <!-- Search -->
        <div class="relative hidden md:block">
            <ng-icon
                name="lucideSearch"
                class="pointer-events-none absolute top-1/2 left-3 h-4 w-4 -translate-y-1/2 text-gray-400"
            />
            <input
                type="text"
                placeholder="Search..."
                class="h-9 w-64 rounded-lg border border-gray-200 bg-gray-50 pr-3 pl-9 text-sm text-gray-700 transition-colors outline-none placeholder:text-gray-400 focus:border-[#1587e8] focus:ring-2 focus:ring-[#1587e8]/20 lg:w-72"
            />
        </div>

        <!-- Notifications -->
        <button
            type="button"
            aria-label="Notifications"
            class="relative flex h-9 w-9 cursor-pointer items-center justify-center rounded-lg text-gray-500 transition-colors hover:bg-gray-100 hover:text-gray-700"
        >
            <ng-icon name="lucideBell" class="text-xl" />
            <span
                class="absolute top-1.5 right-1.5 h-2 w-2 rounded-full bg-[#1587e8] ring-2 ring-white"
            ></span>
        </button>

        <div class="mx-1 hidden h-6 w-px bg-gray-200 sm:block"></div>

        <!-- Profile Dropdown -->
        <app-header-profile-menu
            [userName]="userName()"
            [userRole]="userRole()"
            [userEmail]="userEmail()"
        />
    </div>
</header>
